import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { STATUS_SEARCH_PARAMS_KEY } from './TripPackageStatusFilter';

export const usePackagesFilters = () => {
  const [_, setSearchParams] = useSearchParams();

  const handleChange = useCallback(
    (key: string, value: string | undefined) => {
      if (value != null) {
        setSearchParams(params => {
          params.set(key, value);
          return params;
        });
      } else {
        setSearchParams(params => {
          params.delete(key);
          return params;
        });
      }
    },
    [setSearchParams],
  );

  const handleReset = () => {
    setSearchParams(params => {
      params.delete(STATUS_SEARCH_PARAMS_KEY);
      return params;
    });
  };

  return { handleChange, handleReset };
};
